import { render } from "./Authenticated.vue?vue&type=template&id=74116226&ts=true"
import script from "./Authenticated.vue?vue&type=script&lang=ts"
export * from "./Authenticated.vue?vue&type=script&lang=ts"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__